<!--
 * @Descripttion: 个人中心-企业文化
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 16:08:11
-->
<template>
    <div :class="{ 'user-guide-culture-box': steps.step6 }">
        <div class="culture-title">
            <div>
                <span>企业文化</span>
            </div>
        </div>
        <div v-loading="loading" class="culture-center">
            <div
                v-for="(item, index) in data"
                :key="index"
                :class="`culture-center-item culture-center-item${index + 1}`"
                :style="{ 'background-image': 'url(' + item.image + ')', 'background-size': 'cover' }"
                @click="goCulturalDetails(item)"
            >
                <div :class="`culture-center-item${index + 1}-title`">
                    <span class="title">{{ item.activityCategoryName }}</span>
                </div>
                <div :class="`culture-center-item${index + 1}-text`">
                    <span class="describe">{{ item.activityContent }}</span>
                </div>
                <div :class="`culture-center-item${index + 1}-icon`">
                    <img src="@/assets/pics/user-center/xyg.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getWebActivityCategorysList } from "@/api";
import { getLocalStorage } from "@/libs/mUtils";
import { mapState } from "vuex";
export default {
    name: "UserCenterCulture",
    data() {
        return {
            loading: false,
            data: [],
        };
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    mounted() {
        this.getCategoryList();
    },
    activated() {
        this.getCategoryList();
    },
    methods: {
        goCulturalDetails(item) {
            this.$router.push(`/work-portal/cultural-activities?id=${item.id}`);
        },
        // 获取活动类别
        async getCategoryList() {
            try {
                const auth_user = getLocalStorage("user");
                const username = auth_user.userData.username;
                const { code, body, message } = await getWebActivityCategorysList({
                    username,
                });
                if (code === "0000") {
                    this.data = body.slice(0, 4);
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error("系统错误");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.user-guide-culture-box {
    position: relative;
    z-index: 999;
    background-color: #fff;
    padding-bottom: 20px;
    border-radius: 8px;
    border: 2px solid #3a9d80;
    pointer-events: none;
}
.culture-title {
    height: 50px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
    div {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        padding-top: 20px;
        padding-left: 20px;
    }
}
.culture-center {
    display: flex;
    margin: 0px 20px 0px 20px;
    justify-content: space-between;

    .title,
    .describe {
        width: 100%;
        position: relative;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .culture-center-item {
        width: 25%;
        cursor: pointer;
    }

    .culture-center-item1 {
        height: 144px;
        background: linear-gradient(180deg, #6abeff 0%, #dff1fb 100%);
        padding: 20px;
        position: relative;
        background-image: url("../../../../assets/pics/user-center/bjtp4.png");
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;
        flex: 1;
        margin-right: 20px;

        .culture-center-item1-title {
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 28px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item1-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item1-icon {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
    }
    .culture-center-item2 {
        flex: 1;
        margin-right: 20px;
        height: 144px;
        background: linear-gradient(180deg, #72a8a4 0%, #d1dfe0 100%);
        padding: 20px;
        position: relative;
        background-image: url("../../../../assets/pics/user-center/bjtp2.png");
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;
        .culture-center-item2-title {
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 28px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item2-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item2-icon {
            position: absolute;
            bottom: 20px;
            right: 20px;
            height: 24px;
            width: 24px;
            cursor: pointer;
        }
    }
    .culture-center-item3 {
        flex: 1;
        margin-right: 20px;
        height: 144px;
        background: linear-gradient(180deg, #dcc0aa 0%, #f8e8dc 100%);
        padding: 20px;
        position: relative;
        background-image: url("../../../../assets/pics/user-center/bjtp3.png");
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;
        .culture-center-item3-title {
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 28px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item3-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item3-icon {
            position: absolute;
            bottom: 20px;
            right: 20px;
            height: 24px;
            width: 24px;
            cursor: pointer;
        }
    }
    .culture-center-item4 {
        flex: 1;
        height: 144px;
        background: linear-gradient(180deg, #4caac8 0%, #def3ff 100%);
        padding: 20px;
        position: relative;
        background-image: url("../../../../assets/pics/user-center/bjtp5.png");
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;
        .culture-center-item4-title {
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 28px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item4-text {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        .culture-center-item4-icon {
            position: absolute;
            bottom: 20px;
            right: 20px;
            height: 24px;
            width: 24px;
            cursor: pointer;
        }
    }
}
</style>
